<template>
  <el-select class="td_select"
             v-model="values"
             :loading="loading"
             clearable
             :disabled="disabled"
             @clear="clearAction"
             filterable>
    <el-option
      class="td_option"
      v-for="item in options"
      :key="item.id"
      :label="item.itemName"
      :value="item.itemName"
      @click.native="handleSelect(item)">
    </el-option>
  </el-select>
</template>
<script>
import { validatenull } from '@/tdcommon/validate'
import { getItemsName } from '@/api/tms/inventoryset'

export default {
  name: 'd2-container-username',
  data () {
    return {
      values: this.value,
      options: [],
      loading: false
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    remoteMethod () {
      this.loading = true
      getItemsName().then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = response.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelect (val) {
      this.$emit('change', val)
    },
    clearAction () {
      this.$emit('change', '')
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val)
    },
    value: function (val, oldVal) {
      if (!validatenull(val)) {
        this.values = val
      }
    }
  },
  mounted () {
    this.remoteMethod()
  }
}
</script>

<style lang="scss" scoped>
  .td_option {
    height: 50px;
    display: flex;
    align-items: center;
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-itemsName/index.vue"
}
</vue-filename-injector>
